export enum DealerSpecificServices {
  electric = 'Electric',
  mustang = 'Mustang'
}
